module.exports = __webpack_public_path__ + "media/images/diplomas-65c1270f098b40cd1203097a7471dea7.png";